import { render, staticRenderFns } from "./archivesSearch.vue?vue&type=template&id=196d9ecc&scoped=true&"
import script from "./archivesSearch.vue?vue&type=script&lang=js&"
export * from "./archivesSearch.vue?vue&type=script&lang=js&"
import style0 from "./archivesSearch.vue?vue&type=style&index=0&id=196d9ecc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196d9ecc",
  null
  
)

component.options.__file = "archivesSearch.vue"
export default component.exports